function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

/*
 *  Home Reviews Section
 *    Scripts for the reviews carousel
 *
 *  Version:
 *    1.0.0 - 2020/10/19
 */
import { initCarousel } from "../../objects/carousel";
import { responsiveMediaAbove, responsiveMediaBelow, responsiveQuery } from './../../settings/responsive';
import { CLASS_ACTIVE, CLASS_VISIBLE } from '../../tools/constants/classes'; // Selectors

var SELECTOR_REVIEWS_CONTAINER = '[data-home-reviews]';
var SELECTOR_REVIEWS_WRAP = '[data-reviews-carousel]';
var SELECTOR_REVIEWS_PROGRESS = '[data-reviews-carousel-progress]';
document.querySelectorAll(SELECTOR_REVIEWS_CONTAINER).forEach(function (element) {
  var _breakpoints;

  var progressBar = element.querySelector(SELECTOR_REVIEWS_PROGRESS);
  var carouselWrap = element.querySelector(SELECTOR_REVIEWS_WRAP);
  if (!progressBar || !carouselWrap) return;
  var keenCarousel = initCarousel(carouselWrap, {
    slidesPerView: 1.35,
    loop: true,
    dragSpeed: 2,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, responsiveQuery('SMALL'), {
      slidesPerView: 1.9
    }), _defineProperty(_breakpoints, responsiveQuery('MEDIUM'), {
      created: function created(slider) {
        return slider.destroy();
      }
    }), _breakpoints)
  }, undefined, undefined, undefined, undefined, progressBar);

  var onResize = function onResize() {
    var slider = keenCarousel.slider;

    if (responsiveMediaAbove('MEDIUM')) {
      slider.destroy();
    } else if (responsiveMediaBelow('MEDIUM')) {
      slider.refresh();
    }
  };

  window.addEventListener('resize', onResize);
});